/**
 * Copyright (c) 2018-2023 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Adam Midlik <midlik@gmail.com>
 */
import { PluginCommands } from '../../commands';
export function registerDefault(ctx) {
    Reset(ctx);
    Focus(ctx);
    SetSnapshot(ctx);
    OrientAxes(ctx);
    ResetAxes(ctx);
}
export function Reset(ctx) {
    PluginCommands.Camera.Reset.subscribe(ctx, function (options) {
        ctx.managers.camera.reset(options === null || options === void 0 ? void 0 : options.snapshot, options === null || options === void 0 ? void 0 : options.durationMs);
    });
}
export function SetSnapshot(ctx) {
    PluginCommands.Camera.SetSnapshot.subscribe(ctx, function (_a) {
        var snapshot = _a.snapshot, durationMs = _a.durationMs;
        ctx.managers.camera.setSnapshot(snapshot, durationMs);
    });
}
export function Focus(ctx) {
    PluginCommands.Camera.Focus.subscribe(ctx, function (_a) {
        var center = _a.center, radius = _a.radius, durationMs = _a.durationMs;
        ctx.managers.camera.focusSphere({ center: center, radius: radius }, { durationMs: durationMs });
        ctx.events.canvas3d.settingsUpdated.next(void 0);
    });
}
export function OrientAxes(ctx) {
    PluginCommands.Camera.OrientAxes.subscribe(ctx, function (_a) {
        var structures = _a.structures, durationMs = _a.durationMs;
        ctx.managers.camera.orientAxes(structures, durationMs);
    });
}
export function ResetAxes(ctx) {
    PluginCommands.Camera.ResetAxes.subscribe(ctx, function (_a) {
        var durationMs = _a.durationMs;
        ctx.managers.camera.resetAxes(durationMs);
    });
}
